"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _basePath = _interopRequireDefault(require("../common/constants/basePath"));

var _OrganisationInvite = _interopRequireDefault(require("./OrganisationInvite"));

var _ResetPassword = _interopRequireDefault(require("./ResetPassword"));

var _ManageUser = _interopRequireDefault(require("./ManageUser"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // App Routes

/**
 * Creates the application route components. Basepath will only exist in production
 * when app-core renders these as sub-routes
 *
 * @return {ReactElement}
 */


var _default = [{
  component: _OrganisationInvite.default,
  path: "".concat(_basePath.default, "/invite"),
  unprotected: true
}, {
  component: _ResetPassword.default,
  path: "".concat(_basePath.default, "/reset-password"),
  unprotected: true
}, {
  component: _ManageUser.default,
  path: "".concat(_basePath.default, "/edit/:id")
}];
exports.default = _default;